import { z } from 'zod';

export const dimensionSchema = z.object({
  id: z.string().uuid(),
  matrixId: z.string().uuid(),
  title: z.string().min(1).max(200),
  description: z.string().max(2_000).nullable(),
  displayOrder: z.number().int().min(0),
});
export type Dimension = z.infer<typeof dimensionSchema>;

/**
 * One row of the bulk-replace payload (see `replaceDimensionsInputSchema`).
 * `id` absent/undefined means "new row" — the backend upserts by id and
 * deletes whatever existing row isn't present in the array. Blank-title
 * rows (the default empty row left untouched) are filtered out client-side
 * before this is sent — there is no minimum dimension count.
 */
export const dimensionInputSchema = z.object({
  id: z.string().uuid().optional(),
  title: z.string().min(1).max(200),
  description: z.string().max(2_000).nullable(),
  displayOrder: z.number().int().min(0),
});
export type DimensionInput = z.infer<typeof dimensionInputSchema>;

/** `PUT /matrices/:id/dimensions` body — the full ordered list, every time. */
export const replaceDimensionsInputSchema = z.array(dimensionInputSchema).max(100);
export type ReplaceDimensionsInput = z.infer<typeof replaceDimensionsInputSchema>;
